import apiFarms from "../config/api_farms";
import getHeaders from "./getHeaders";

export function indexFeedingAutomation(payload) {
  const { groupId, farmId, startDate, endDate, page, size, signal } = payload;
  const params = new URLSearchParams();
  if (startDate) params.append("start_date", startDate);
  if (endDate) params.append("end_date", endDate);
  if (page != null) params.append("page", page);
  if (size != null) params.append("size", size);
  const queryString = params.toString();

  return apiFarms.get(
    `/bovexo/${groupId}/farms/${farmId}/feeding/automation/manufactures${
      queryString !== "" ? `?${queryString}` : ""
    }`,
    getHeaders(false, signal),
  );
}

export function showFeedingAutomation(payload) {
  const { groupId, farmId, id, signal } = payload;

  return apiFarms.get(
    `/bovexo/${groupId}/farms/${farmId}/feeding/automation/manufactures/${id}`,
    getHeaders(false, signal),
  );
}
